import { useRef, type ReactNode } from 'react';
import { useReportCardHeight } from '../../hooks/useEmbeddedHost';
import { useEmbeddedAppearance } from '../../hooks/useEmbeddedAppearance';
import { shellSizeStyle } from './shellSizes';
import EmbeddedCrashBoundary from './CrashBoundary';

const CARD = shellSizeStyle({
  minHeight: 270,
  maxHeight: 440,
  borderWidth: 1,
  radius: 16,
  helpRowHeight: 32,
  linkHeight: 28,
  linkPaddingX: 4,
});

/**
 * EmbeddedCardShell — Card mode: the card sits inline in the website's page,
 * and the iframe follows its height.
 */
export default function EmbeddedCardShell({
  children,
}: {
  children: ReactNode;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useReportCardHeight(ref);
  const appearance = useEmbeddedAppearance('card');

  return (
    <div
      ref={ref}
      data-testid="embedded-card-shell"
      className="w-full font-inter"
      style={{ ...CARD, ...appearance }}
    >
      <EmbeddedCrashBoundary>{children}</EmbeddedCrashBoundary>
    </div>
  );
}
